import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "hiringCard" && !(_id in path('drafts.**'))][0]`;
}
